export enum Cursor {
  DEFAULT = "default",
  POINTER = "pointer",
  MOVE = "move",
  GRAB = "grab",
  GRABBING = "grabbing",
  NS_RESIZE = "ns-resize",
  EW_RESIZE = "ew-resize"
}
